import { Module } from "vuex-smart-module"

import MapState from "./state"
import MapMutations from "./mutations";
import MapGetters from "./getters";
import MapActions from "./actions"

export const mapModule = new Module({
    state: MapState,
    getters: MapGetters,
    mutations: MapMutations,
    actions: MapActions
})